module.exports = "/ui/images/ajax-loader.gif";